let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("grPyn")).then(() => parcelRequire('bi6bT'));